import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const ProfileMenu = Record({
    didFetchAccounts: false,
    accounts: List(),
    showWhatsNewNotificationBadge: false,
    sentryRecordingId: null,
});

export default handleActions(
    {
        [Actions.fetchLoginsSuccess.type]: (state, {payload}) => {
            return state.merge({
                didFetchAccounts: true,
                accounts: payload.accounts,
            });
        },

        [Actions.setShowWhatsNewNotificationBadge.type]: (state, {payload}) =>
            state.merge({
                showWhatsNewNotificationBadge: payload.showWhatsNewNotificationBadge,
            }),

        [Actions.startSentryRecording.type]: (state, {payload}) => {
            return state.merge({
                sentryRecordingId: payload.sentryRecordingId,
            });
        },
        [Actions.stopSentryRecording.type]: state => {
            return state.merge({
                sentryRecordingId: null,
            });
        },
    },
    new ProfileMenu(),
);
